// hooks
import { useAppNotifications } from 'hooks/useAppNotifications'

const AppNotifications = () => {
  useAppNotifications()

  return null
}

export default AppNotifications
